import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmFeatureUsageRoute: InvariantJiraRoute = {
	name: 'products-jsm-feature-usage',
	path: '/jira/settings/products/servicedesk/feature-usage',
	exact: true,
};
